import { render, staticRenderFns } from "./addFactory.vue?vue&type=template&id=64e9e2b4&"
import script from "./addFactory.vue?vue&type=script&lang=js&"
export * from "./addFactory.vue?vue&type=script&lang=js&"
import style0 from "./addFactory.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "addFactory.vue"
export default component.exports